import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'
import teacher1 from '../Assets/images/teacher1.jpg'
import teacher2 from '../Assets/images/nizar.png'
import teacher3 from '../Assets/images/amira.png'
import teacher4 from '../Assets/images/mostafa.png'
import teacher5 from '../Assets/images/nour.png'
import teacher6 from '../Assets/images/enas.jpg'
import teacher7 from '../Assets/images/refat.png'
import teacher8 from '../Assets/images/zainab.png'
import { Modal } from 'antd';
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup';
import img1 from "../Assets/images/Vector5.png"

const OurTeachers = () => {

    const { t } = useTranslation();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const teachers = [
        { id: 1, name: t("teacher1.name"), text: t("teacher1.text"), image: teacher1 },
        { id: 2, name: t("teacher2.name"), text: t("teacher2.text"), image: teacher2 },
        { id: 3, name: t("teacher3.name"), text: t("teacher3.text"), image: teacher3 },
        { id: 4, name: t("teacher4.name"), text: t("teacher4.text"), image: teacher4 },
        // { id: 5, name: t("teacher5.name"), text: t("teacher5.text"), image: teacher5 },
        { id: 6, name: t("teacher6.name"), text: t("teacher6.text"), image: teacher6 },
        { id: 7, name: t("teacher7.name"), text: t("teacher7.text"), image: teacher7 },
        { id: 8, name: t("teacher8.name"), text: t("teacher8.text"), image: teacher8 }
    ];

    return (
        <div className='our-teachers'>
            <section className='first-section '>
                <h2 className='mb-3'>{t("our_teachers_title")}</h2>
                <p className='mb-4'>
                    {t("our_teachers_text")}
                </p>
            </section>

            <Row className='justify-content-start flex-column '>
                <Col md={12} className='green-div'>
                    <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                        <button className='btn fw-bold' onClick={() => setIsModalOpen(true)} >{t("start_now")}</button>
                    </div>
                </Col>
            </Row>

            <section className='second-section w-100 mt-5'>
                <div className=' d-flex flex-column justify-content-center align-items-center '>
                    <h3>{t("learn_with_experts")}</h3>

                </div>
                <Container className='my-5'>
                    {teachers.map((teacher) => (
                        <div className='teacher-testimonial mb-4 mt-4 ph-btns last-sec' key={teacher?.id}>
                            <img src={teacher?.image} />
                            <div>
                                <h2>{teacher.name}</h2>
                                <p>{teacher.text}</p>
                                <button className='btn-ph-Questions' onClick={() => setIsModalOpen(true)}>{t("start_today2")}</button>
                            </div>
                        </div>
                    ))}

                </Container>
            </section>
            <section className='my-5'>
                <div className='fifth-section mt-5'>
                    <Container>
                        <h4>{t('students_love_us')}</h4>
                        <img src={img1} alt='' className='w-100' />
                        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
                            <div className="carousel-indicators">
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            </div>

                            <div className="carousel-inner">

                                <div className="carousel-item active">
                                    <div className="row my-3 pb-5 gx-5 mx-5">
                                        <div className="col-lg-6">
                                            <div className="card h-100">
                                                <p>{t("testimonial_1_text")}</p>
                                                <h5 className='mt-3'>{t("testimonial_1_author")}</h5>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="card h-100">
                                                <p>{t("testimonial_2_text")}</p>
                                                <h5 className='mt-3'>{t("testimonial_2_author")}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="carousel-item">
                                <div className="row my-3 pb-5 gx-5 mx-5">
                                    <div className="col-lg-6">
                                        <div className="card h-100">
                                            <p>{t('testimonials.testimonial1.text')}</p>
                                            <h5 className='mt-3'>{t('testimonials.testimonial1.name')}</h5>
                                            <h6>{t('testimonials.testimonial1.title')}</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="card h-100">
                                            <p>{t('testimonials.testimonial2.text')}</p>
                                            <h5 className='mt-3'>{t('testimonials.testimonial2.name')}</h5>
                                            <h6>{t('testimonials.testimonial2.title')}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            </div>

                            {/* Controls */}
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">{t('testimonials.prev')}</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">{t('testimonials.next')}</span>
                            </button>
                        </div>
                    </Container>

                    <Modal
                        open={isModalOpen}
                        footer={null}
                        destroyOnClose
                        onCancel={() => setIsModalOpen(false)} // close handler
                        width={"80vw"}

                    >
                        <RegistrationPopup setIsModalOpen={setIsModalOpen} />
                    </Modal>
                </div>
            </section>
        </div>
    )
}

export default OurTeachers
